import axios from 'axios';
import router from '../router'
import { Message } from 'element-ui'

// 创建axios实例
const service = axios.create({
  // axios中请求配置有baseURL选项，表示请求URL公共部分
  baseURL: process.env.VUE_APP_BASE_URL,
})
// request拦截器
service.interceptors.request.use(config=>{
  // console.log('request.config', config.params)
  return config
})

// response拦截器
service.interceptors.response.use(
  res=>{
    if(res.data.code === 1){
      // 业务异常
      Message({message: res.data.msg, type: 'error', duration: 3 * 1000})
    } else if(res.data.code === 2) {
      // 未登录
      Message({message: res.data.msg, type: 'warning', duration: 3 * 1000})
      const timer = setTimeout(() => {
        router.push('/login', ()=>{})
        localStorage.removeItem('userId')
        localStorage.removeItem('userName')
        clearInterval(timer);
      }, 2000);
    }
    return res.data
  },
  error => {
    let {message} = error;
    if (message === "Network Error") {
        message = "后端接口连接异常";
    } else if (message.includes("timeout")) {
        message = "系统接口请求超时";
    } else if (message.includes("Request failed with status code")) {
        message = "系统接口" + message.substr(message.length - 3) + "异常";
    }
    Message({message: message, type: 'error', duration: 3 * 1000})
    return Promise.reject(error)
  }
)

export default service
